var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaveFilteWarningIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5A623",
    fillRule: "nonzero",
    d: "M2.511 13h9.796c1.612 0 2.625-1.806 1.827-3.219L9.22 1.083a2.056 2.056 0 0 0-3.624 0L.684 9.781C-.099 11.211.9 13 2.511 13zm4.913-1.931a.795.795 0 0 1-.783-.8c0-.44.353-.802.783-.802.43 0 .783.362.768.817.015.424-.353.785-.768.785zm-.2-7.222a.775.775 0 0 1 .906.455c.047.126.077.251.077.392-.015.393-.046.801-.077 1.194-.03.612-.076 1.24-.107 1.852-.015.204-.015.377-.015.581-.016.33-.261.581-.584.581a.573.573 0 0 1-.583-.565c-.046-.958-.108-1.916-.154-2.873l-.046-.77c-.015-.392.215-.737.584-.847z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveFilteWarningIcon);
export default __webpack_public_path__ + "static/media/SaveFilteWarningIcon.b94174c62263ae0b3f82bbcaa3329782.svg";
export { ForwardRef as ReactComponent };